import { defaultLocale } from './consts';
import warn from '../warn';

export const createTLoader = ({ componentName, customTLoader }) => locale => {
  try {
    return customTLoader({ locale });
  } catch (e) {
    warn(`
Locale has changed to '${locale}' but the component '${componentName}' doesn't have the correct localization file for it.
You can supply a custom loading function to 'createTLoader' like so:
"createTLoader({ componentName: ${componentName}, customTLoader: ({ locale }) => new MDText(require(\`path/to/my/custom/locale/\${locale}.json\`)) })"
`);
    return customTLoader({ locale: defaultLocale });
  }
};
